<template>
  <div
    class="document-tab-container"
    @click="$emit('document-click', document.id)"
  >
    <div class="document-tab-header">
      <div class="document-tab-content">
        <div class="document-tab-title">
          {{document.type.name}}
        </div>
        <div
          class="document-tab-subtitle"
          v-bind:class="{success: isSigend}"
        >
          {{isSigend ? 'Підписано' : 'Чекає підпису'}}
        </div>
      </div>

      <svg class="icon-right" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L7 7L1 13" stroke="#00050A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div v-if="signatures && signatures.length > 0" >
      <div
        class="document-signer"
        v-for="signature in signatures"
        v-bind:key="signature.signer_name + signature.signing_date_time"
      >
        <div class="signer-name">
          {{ signature.signer_name }}
        </div>
        <div class="signer-date">
          {{ signature.signing_date_time }}
        </div>
        <div class="signer-type">
          {{ signature.signer_organization }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentTab',
  props: ['document'],
  computed: {
    signatures (vm) {
      const { p7s, signatures } = vm.$props.document
      if (p7s && p7s.length > 0) {
        const [lastP7s] = p7s
        return lastP7s.attr.signatures
      }

      return signatures
    },
    isSigend: (vm) => {
      const { signatures, p7s } = vm.$props.document
      return (signatures && signatures.length > 0) || (p7s && p7s.length > 0)
    }
  }
}
</script>

<style lang="less" scoped>
.document-tab-container {
  display: flex;
  flex-flow: column;
  align-items: flex-start !important;
  padding: 12px 16px 12px 21px;

}
.document-tab-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
  margin-bottom: 8px;
}
.document-tab-title {
  font-size: 16px;
  font-weight: bold;
  color: var(--black);
}
.document-tab-subtitle {
  font-size: 14px;
  color: var(--grey-140);
}
.icon-right {
  margin-left: 21px;
  path {
    stroke: var(--grey-140);
  }
}

.success {
  color: var(--green);
}

.document-signer {
  width: 100%;
  margin: 8px auto;
  font-size: 12px;
}

.signer-date,
.signer-type {
  color: var(--grey-140)
}
</style>
